// ═════════════════════════════════════════════════════════════════════════════
//  EL BOTON DE LA RUTINA · prefijo crb-
//
//  Vive al lado del engrane, arriba, y solo existe si hay rutina de hoy. Es el
//  «checalo arriba» que pide el coach cuando acaba de montarla.
//
//  ── POR QUE UN ANILLO Y NO UN NUMERITO ──────────────────────────────────────
//  El boton lleva el avance dibujado en el borde: el anillo se va cerrando
//  segun cierra estaciones. Un contador («2/4») obliga a leer; un anillo se ve
//  de reojo, que es como se mira un boton de una esquina.
//
//  ── EL LATIDO ───────────────────────────────────────────────────────────────
//  Cuando el coach acaba de crear la rutina, el boton late. Y PARA de latir en
//  cuanto se abre: un adorno que no se apaga deja de significar nada y pasa a
//  molestar. El latido no dice "aqui hay un boton", dice "hay algo NUEVO aqui",
//  y eso solo es verdad una vez.
// ═════════════════════════════════════════════════════════════════════════════

import "./CoachRutinaBoton.css";

// El anillo se dibuja con un SVG y no con un `conic-gradient` porque tiene que
// convivir con la sombra neumorfica del boton: un gradiente de fondo tapa el
// relieve, y el relieve es el idioma de esta pantalla.
const R = 17;
const VUELTA = 2 * Math.PI * R;

export default function CoachRutinaBoton({ rutina, late, textos, onAbrir }) {
  if (!rutina?.pasos?.length) return null;

  const total = rutina.pasos.length;
  const hechos = rutina.pasos.filter(p => p.hecho_a_las).length;
  const completa = hechos === total;

  return (
    <button
      className={"crb-boton"
        + (late ? " crb-late" : "")
        + (completa ? " crb-completa" : "")}
      onClick={onAbrir}
      aria-label={textos.rutinaAbrir(hechos, total)}
      title={textos.rutinaTitulo}
    >
      <svg className="crb-anillo" viewBox="0 0 40 40" aria-hidden="true">
        <circle className="crb-carril" cx="20" cy="20" r={R} />
        <circle
          className="crb-avance"
          cx="20" cy="20" r={R}
          strokeDasharray={VUELTA}
          strokeDashoffset={VUELTA * (1 - hechos / total)}
        />
      </svg>

      {/* El icono es la pesa del gimnasio, el mismo que abre "Entrenar" abajo:
          el alumno ya sabe lo que significa. */}
      <span className="crb-icono" aria-hidden="true">
        {completa ? "🏆" : "🏋️"}
      </span>

      {/* El punto de "nuevo". Se va con el latido, en cuanto la abre. */}
      {late && <span className="crb-punto" aria-hidden="true" />}
    </button>
  );
}
